 <template>
    <div>
        <vxe-table border ref="xTable" :data="files" :loading="loading" :style="{ marginTop: '10px' }">
            <vxe-column min-width="120" field="name" title="附件名称">
                <template #default="{ row }">
                    {{ row.name }}
                    <span v-if="!row.path" style="color: #F56C6C; margin-left: 6px;">无权查看</span>
                </template>
            </vxe-column>
            <vxe-column width="160" field="created_at" title="上传日期"></vxe-column>
            <vxe-column width="100" field="stage" title="上传时机"></vxe-column>
            <vxe-column width="100" field="user.name" title="上传人"></vxe-column>
            <vxe-column width="120" align="center" fixed="right">
                <template #default="{ row }">
                    <el-link v-if="row.path" type="primary" class="w-margin-r-10" @click.stop="$refs.filesPreview.Open(row.id, row.path, 'preview')">预览</el-link>
                    <el-link v-if="row.path" type="primary" class="w-margin-r-10" @click.stop="$refs.filesPreview.Open(row.id, row.path, 'down')">下载</el-link>
                    <el-link type="danger"  @click.stop="FilesDelete(row)">移除</el-link>
                </template>
            </vxe-column>
        </vxe-table>
        <files-preview ref="filesPreview" :preview-type="previewType" :preview-direction="previewDirection" :preview-modal="previewModal" :drawer-size="drawerSize" />
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Array,
            default: function () {
                return []
            }
        },
        span: {
            type: Number,
            default: 8
        },
        drawerSize: {
            type: [String, Number],
            default: '80%'
        },
        previewType: {
            type: String,
            default: 'dialog'
        },
        previewDirection: {
            type: String,
            default: 'rtl'
        },
        previewModal: {
            type: Boolean,
            default: true
        },
        projectsId: {
            type: [Number, String],
            default: null
        }
    },
    data () {
        return {
            loading: false,
            files: [],
        }
    },
    watch: {
        value: {
            handler () {
                if (JSON.stringify(this.value) != JSON.stringify(this.files.map(item => item.id))) {
                    this.FilesSearchIds()
                }
            },
            immediate: true,
        }
    },
    methods: {
        FilesSearchIds() {
            const payload = { ids: this.value }
            if (this.projectsId) {
                payload.projects_id = this.projectsId
            }
            this.$http.post('/9api/components-files/search-ids', payload).then(rps => {
                new Promise((resolve) => {
                    this.files = rps.data
                    resolve()
                }).then(rps => {
                    this.$emit('input', this.files.map(item => item.id))
                })
            })
        },
        FilesDelete(row) {
            this.$confirm('确认移除附件「' + (row.name || '') + '」吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post('/9api/components-files/delete', {id: row.id}).then(rps => {
                    if (!rps) return
                    new Promise((resolve) => {
                        this.files = this.files.filter(item => item.id != row.id)
                        resolve()
                    }).then(rps => {
                        this.$emit('input', this.files.map(item => item.id))
                    })
                })
            }).catch(() => {})
        },
    }
}
</script>